export const NameValue = (name: string | JSX.Element, value: any) => {
  return { name, value }
}
